import Page from "../../../api/Page";
import QRCodeIcon from "../../../api/qr-code/icon/QRCodeIcon";
import {createContext} from "react";
import GetListQuery from "../../../api/qr-code/icon/GetListQuery";
import CreateAndPutPayload from "../../../api/qr-code/icon/CreateAndPutPayload";

type QRCodeIconContextType = {
    /**
     * Data from API
     * @author Kacper Faber
     * @since 0.1.9
    */
    data: Page<QRCodeIcon> | undefined;

    /**
     * Updates the data in context.
     * @author Kacper Faber
     * @since 0.1.9
    */
    setData: (data: Page<QRCodeIcon> | undefined) => void;

    /**
     * Query to fetch the data
     * @author Kacper Faber
     * @since 0.1.9
    */
    query: GetListQuery;

    /**
     * Updates the query in the context.
     * If you change the query, context will reload the data
     * @author Kacper Faber
     * @since 0.1.9
    */
    setQuery: (query: GetListQuery) => void;

    /**
     * Force reload the data
     * @author Kacper Faber
     * @since 0.1.9
    */
    reload: () => void;

    /**
     * Create new QRCodeIcon in API.
     * Instantly refresh the state, if success
     * @author Kacper Faber
     * @since 0.1.9
    */
    create: (payload: CreateAndPutPayload) => Promise<QRCodeIcon>;
}

const notImplemented = () => {
    throw new Error('Not Implemented');
};

const defaultQuery: GetListQuery = {  };

/**
 *
 * @author Kacper Faber
 * @since 0.1.9
*/
const defaults: QRCodeIconContextType = {
    data: undefined,
    setData: notImplemented,
    query: defaultQuery,
    setQuery: notImplemented,
    reload: notImplemented,
    create: notImplemented
};

/**
 * Context to hold QRCodeIcons.
 * @author Kacper Faber
 * @since 0.1.9
*/
const ctx = createContext<QRCodeIconContextType>(defaults);

export default ctx;